EventBus.subscribe('isTouchDevice', function () {
    jQuery('html').addClass('touch');
}).subscribe('isNotTouchDevice', function () {
    jQuery('html').addClass('no-touch');
});